import React, { useEffect } from 'react';
import Banner from '../Banner/Banner';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProductDetails } from '../../redux/slices/productDetailsSlice';

const ProductDetails = () => {
  const { t, i18n } = useTranslation('global');
  const { id } = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  const { product, isLoading, error } = useSelector((state) => state.productDetails);

  useEffect(() => {
    if (id) {
      dispatch(fetchProductDetails({ id, lang: i18n.language }));
    }
  }, [dispatch, id, i18n.language]);

  console.log(product)
  return (
    <div className="product_details">
      <Banner
        currentPage={t(product?.labelKey || "products.productDetails")}
        bg={`url(../../Products/details.jpg)`}
      />

      <div className="container py-5">
        <div className="row justify-content-center">
          {isLoading ? (
            <p className="text-center">{t("loading")}</p>
          ) : error ? (
            <p className="text-center text-danger">{error.message || error}</p>
          ) : product?.data.length > 0 ? (
            product?.data.map((subItem, index) => (
              <div className="col-xl-4 col-lg-4 col-md-6 col-12" key={index}>
                <div className="sub_item_card my-2 text-center rounded-2 border p-3 shadow-sm">
                  <img
                    src={subItem.image}
                    alt={t(subItem.labelKey)}
                    className="img-fluid mb-2 w-100 rounded-3"
                    style={{ maxHeight: "170px", objectFit: "cover" }}
                  />
                  <h5 className="my-2 sub-color">{t(subItem.title)}</h5>
                  <p className="my-2 ">{t(subItem.desc)}</p>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-4">
              <img
                src="/remove.gif"
                className="mx-auto"
                style={{ width: "auto", maxHeight: "60px" }}
                alt={t("products.noSubItems")}
              />
              <p className="my-2 text-lg">{t("products.noSubItems")}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductDetails;
